var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xy-pageLoadingIndicator"},[_c('div',{staticClass:"xy-pageLoadingIndicator-fill",class:("isStatus" + _vm.status)},[(_vm.status !== 0)?_c('div',{staticClass:"xy-pageLoadingIndicator-highlightAnimation"}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }